// extracted by mini-css-extract-plugin
module.exports = {"logo-loading":"styles_logo-loading__2db69"};